import { useContext } from "react";
import { themeModeContext } from "../providers/themeMode";

export function useThemeMode() {
  return useContext(themeModeContext);
}
